export default {
  zh: {
    questionnaire: "KYC问卷",
    expound: "本界面的KYC问卷主要为满足政府的反洗钱等合规要求而设置，以便我们更好地了解您的业务",
    workTitle: "你在新加坡设立公司准备从事什么业务？",
    workFundTitle: "你在新加坡设立基金管理公司准备从事什么业务？",
    causeTitle: "公司在新加坡设立的原因(多选项，至少选一项)",
    causeFundTitle: "业务在新加坡设立的原因(多选项，至少选一项)",
    causeInfo: "该信息将用于政府要求的反洗钱检查",
    causeOption01: "我住在新加坡",
    causeOption02: "现有业务的扩展",
    causeOption03: "进入亚洲市场",
    causeOption04: "业务伙伴要求",
    causeOption05: "新加坡作为国际公认的枢纽，以新加坡为跳板进行海外业务扩展",
    otherOption: "其他，请列明",
    sourceTitle: "公司注资以及未来运营的资金来源(多选项，至少选一项)",
    sourceFundTitle: "业务注资以及未来运营的资金来源(多选项，至少选一项)",
    sourceOption01: "薪资",
    sourceOption02: "经营产生的利润",
    sourceOption03: "投资盈利",
    sourceOption04: "借款(如银行、金融机构)",
    sourceOption05: "从家庭和朋友的借款",
    sourceOption06: "个人储蓄",
    sourceOption07: "遗产",
    sourceOption08: "投资人",
    contactTitle: "您的业务是否直接或间接与克里米亚、古巴、伊朗、朝鲜或叙利亚打交道？",
    supplierTitle: "您的供货商主要在哪些国家？(多选项，至少选一个国家)",
    clientTitle: "您的客户主要在哪些国家？(多选项，至少选一个国家)",
    financing: "预期未来以现金(即非银行转款、非电子钱包转款)的交易比例",
    financingOption01: "不低于50%",
    financingOption02: "低于50%",
    atDutiesTitle: "(拟设)公司的申请人/董事/股东是否为政治敏感人士，即在新加坡境内、或其他国籍和地区，或任何一个国际组织目前担任敏感的政治职务？",
    atDutiesFundTitle: "(拟设)基金和基金管理公司的申请人/董事/股东是否为政治敏感人士，即在新加坡境内、或其他国籍和地区，或任何一个国际组织目前担任敏感的政治职务？",
    onceDutiesTitle: "(拟设)公司的申请人/董事/股东是否为政治敏感人士，即在新加坡境内、或其他国籍和地区，或任何一个国际组织曾经担任敏感的政治职务？",
    onceDutiesFundTitle: "(拟设)基金和基金管理公司的申请人/董事/股东是否为政治敏感人士，即在新加坡境内、或其他国籍和地区，或任何一个国际组织曾经担任敏感的政治职务？",
    relativeTitle: "(拟设)公司的申请人/董事/股东是否为为目前或曾经担任政治敏感人士的直系亲属和密切关系人？",
    relativeFundTitle: "(拟设)基金和基金管理公司的申请人/董事/股东是否为为目前或曾经担任政治敏感人士的直系亲属和密切关系人？",
    criminalRecord: "(拟设)董事/股东是否事先有涉及欺诈或不诚实的刑事定罪？",
    criminalRecordFundTitle: "(拟设)基金和基金管理公司董事/股东是否事先有涉及欺诈或不诚实的刑事定罪？",
    finalBeneficiary: "最终受益人信息",
    finalFundBeneficiary: "(拟设)基金管理公司的最终受益人信息",
    addBeneficiary: "添加最终受益人",
    tipeBeneficiary:
      "根据Gov的指引说明，关于“实际控制人”(即最终受益人)的定义为：如果个人/法人实体 (i) 有权行使或 (ii) 实际对公司施加重大影响或控制，则该个人/法人实体为公司的控制人。同时，Gov给出了25%的股权或投票权作为参考基准来判断是否为实际控制人。",
    countryOrNationality: "国家(国籍)",
    companyForm: "公司",
    personalForm: "个人",
    wayToGetThisTitle: "你是如何知道我们提供的公司服务(多选项，至少选一项)",
    wayToGetThisFundTitle: "你是如何知道我们提供的基金管理公司服务(多选项，至少选一项)",
    informationProposed: "(拟设)公司的直接股东/董事信息",
    informationFundProposed: "(拟设)基金管理公司的直接股东/董事信息",
    informationFundTitle: "(拟设)基金的直接股东/董事信息",
    proposedCompanyName: "公司名称",
    appointAny: "是否已聘用EStar提供的名义董事:",
    appointAnyYes: "是, 请输入董事名称",
    appointAnyNo: "否",
    fundManagersName: "基金管理公司名称",
    fundInformation: "基金信息",
    addFundInformation: "添加基金",
    proposedFundName: "基金名称",
    fundType: "类型",
    registrationCountry: "注册国家",
    registrationAddress: "注册地址",
    fundsInvestedCountryTitle: "基金投资哪些国家? (多选项，至少选一个国家)",
    fundsInvestedTypeTitle: "基金投资哪些投资类型? (多选项，至少选一个类型)",
    proposalFundName: "(拟设)基金名称",
    copyShareholderOrDirectors: "拷贝股东/董事信息",
    copyShareholderOrDirectorsHint: "为节省你的时间，可通过该选项选择该公司/基金的股东/董事信息至本处。",
    proposedCompanyIncorporationDate: "(拟设)公司设立日期",
    proposedCompanyFinancialYearEnd: "(拟设)公司财年结束日",
    proposedCompanyFirstFinancialYearEnd: "(拟设)公司第一个财年结束日",
  },
  en: {
    questionnaire: "KYC Questionnaire",
    expound:
      "The KYC Questionnaire below is mainly set up to meet the government's anti-money laundering and other compliance requirements, so that we can better understand your business:",
    workTitle: "What kind of business do you intend to do?",
    workFundTitle: "What kind of business do you intend to do?",
    causeTitle: "Why are you interested in incorporating your business in Singapore? (Multiply choices, to select at least 1)",
    causeFundTitle: "Why are you interested in incorporating your business in Singapore? (Multiply choices, to select at least 1)",
    causeInfo: "For government requested AML purpose",
    causeOption01: "I reside in Singapore",
    causeOption02: "Expansion of existing business",
    causeOption03: "Entering into Asia",
    causeOption04: "Requested by parties we work with",
    causeOption05: "Singapore is an international recognised hub",
    otherOption: "Others, please specify",
    sourceTitle: "Please select all sources for your company's fund (Multiply choices, to select at least 1)",
    sourceFundTitle: "Please select all sources for your business's fund (Multiply choices, to select at least 1)",
    sourceOption01: "Savings from employment",
    sourceOption02: "Profits generated from business",
    sourceOption03: "Investment gain",
    sourceOption04: "Loans (e.g. Banks or Financial Institutions)",
    sourceOption05: "Loans from family and friends",
    sourceOption06: "Personal savings",
    sourceOption07: "Inheritance",
    sourceOption08: "Investors",
    contactTitle: "Does your business deal directly or indirectly with Crimea, Cuba, Iran, North Korea, or Syria?",
    supplierTitle: "Which country do your suppliers come from? (Multiple options, select at least one country)",
    clientTitle: "Which country do your customers come from? (Multiple options, select at least one country)",
    financing: "What percentage of transactions are expected to be cash (i.e. non-bank, non-e-wallet) in the future?",
    financingOption01: "More than 50%",
    financingOption02: "Less than 50%",
    atDutiesTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed company a political exposed person, that is, a person who is or has been entrusted with any prominent public function in Singapore, a country or territory outside Singapore, or by an international organization at present?",
    atDutiesFundTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed fund(s) and fund manager a political exposed person, that is, a person who is or has been entrusted with any prominent public function in Singapore, a country or territory outside Singapore, or by an international organization at present?",
    onceDutiesTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed company a political exposed person, that is, a person who is or has been entrusted with any prominent public function in Singapore, a country or territory outside Singapore, or by an international organization who has stepped down from his prominent public function?",
    onceDutiesFundTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed fund(s) and fund manager a political exposed person, that is, a person who is or has been entrusted with any prominent public function in Singapore, a country or territory outside Singapore, or by an international organization who has stepped down from his prominent public function?",
    relativeTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed company an immediate family member or a close associate of a politically exposed person or a politically exposed person who has stepped down?",
    relativeFundTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed fund(s) and fund manager an immediate family member or a close associate of a politically exposed person or a politically exposed person who has stepped down?",
    criminalRecord: "Do the proposed director(s)/shareholder(s) have prior criminal convictions involving fraud or dishonesty?",
    criminalRecordFundTitle: "Do the proposed director(s)/shareholder(s) of the proposed fund(s) and fund manager have prior criminal convictions involving fraud or dishonesty?",
    finalBeneficiary: "Information of the proposed company's Ultimate Beneficial Owner(s)",
    finalFundBeneficiary: "Information of the proposed fund manager's Ultimate Beneficial Owner(s)",
    addBeneficiary: "Add beneficial owner",
    tipeBeneficiary:
      'According to Gov guidelines, "Actual Owner" (i.e. Ultimate Beneficial Owner) is defined as a person/legal entity who (I) has the authority to exercise or (ii) exerts significant influence or control over the Company.At the same time, Gov gives 25% of the equity or voting rights as a reference benchmark to judge whether the actual controller is the owner.',
    countryOrNationality: "Country / Nationality",
    companyForm: "Company",
    personalForm: "Individual",
    wayToGetThisTitle: "How do you know EStar's online corporate services? (Multiple choices, at lease one)",
    wayToGetThisFundTitle: "How do you know EStar's online corporate services? (Multiple choices, at lease one)",
    informationProposed: "Information of the proposed company's officer(s)",
    informationFundProposed: "Information of the proposed fund manager's officer(s)",
    informationFundTitle: "Information of the proposed fund's officer(s)",
    proposedCompanyName: "Proposed Company Name",
    appointAny: "Did you appoint any nominee director provided by EStar:",
    appointAnyYes: "Yes, please provide the director's name",
    appointAnyNo: "No",
    fundManagersName: "Fund Manager's Name",
    fundInformation: "Business Information of the Proposed Funds",
    addFundInformation: "Add fund",
    proposedFundName: "Proposed Fund Name",
    fundType: "Type",
    registrationCountry: "Registration Country",
    registrationAddress: "Registration address",
    fundsInvestedCountryTitle: "Which country do your fund(s) invested in? (Multiple options, select at least one country)",
    fundsInvestedTypeTitle: "What type of investments do your fund(s) invested in? (Multiple options, select at least one type)",
    proposalFundName: "Proposed Fund Name",
    copyShareholderOrDirectors: "Copy from",
    copyShareholderOrDirectorsHint:
      "To save your time, you can select the name of the company/fund through this option so that the shareholder/director information in this system can be copied here.",
    proposedCompanyIncorporationDate: "Proposed Company's Incorporation Date",
    proposedCompanyFinancialYearEnd: "Proposed Company's Financial Year End",
    proposedCompanyFirstFinancialYearEnd: "Proposed Company's First Financial Year End",
  },
};
